import type { ILineItem } from '@/types/IOrderV2';
import React from 'react';

type Props = {
  productsOrdered: ILineItem[] | null;
};

function renderProductItem(product: ILineItem) {
  return (
    <div key={product.id} className="text-xs mb-1">
      <span className="font-medium">{product.name}: </span>
      <span>Qty {product.quantity}</span>
    </div>
  );
}

const ProductsOrderedDetails: React.FC<Props> = ({ productsOrdered }) => {
  if (!productsOrdered || productsOrdered.length === 0) return null;

  return (
    <div className="max-w-fit bg-brand-50 rounded-lg px-4 py-6 mb-3">
      <div className="text-gray-700 text-xs font-semibold uppercase">
        Products ordered
      </div>
      <div className="mt-6">
        {productsOrdered.map(renderProductItem)}
      </div>
    </div>
  );
};

export default ProductsOrderedDetails;
